<template>
	<div>
		<router-view />
		<AmbitLoader></AmbitLoader>
		<Error></Error>
	</div>
</template>

<script>
    import AmbitLoader from './components/AmbitLoader.vue';
    import Error from './components/Error.vue';
export default {
	name: 'App',
        components: {
			AmbitLoader, Error
        },
	data: () => ({
		//
	}),
};
</script>
